import { type ReactNode, useEffect, useState } from 'react';
import { toDataURL } from 'qrcode';
import styles from './qr-code.module.css';

export interface QrCodeProps {
  url?: string;
  fallbackSrc?: string;
}

export function QrCode({ url, fallbackSrc }: QrCodeProps): ReactNode {
  const [src, setSrc] = useState(fallbackSrc);

  useEffect(() => {
    // oxlint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
    if (url) {
      void toDataURL(url, {
        type: 'image/png',
        width: 160,
        margin: 0,
        color: {
          dark: '#000000FF',
          light: '#00000000',
        },
      }).then(dataURL => {
        setSrc(dataURL);
      });
    }
  }, [url]);

  return <img alt="" className={styles.img} data-test-qr-code src={src} />;
}
